module.exports = __webpack_public_path__ + "static/img/wuhanwei1.1efa133.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wuhanwei1.png
// module id = JP1B
// module chunks = 1